import React from "react";
import { Col, Row } from 'antd';
import FeatureData from "./FeatureData";
const Features = () => {
  const script = document.createElement("script");
  script.src = "./assets/js/Frontscript.js";
  script.type = 'text/javascript';
  script.async = true;
  document.body.appendChild(script);

  const Fdata = (val) => {
    return (
      <li key={val.id}><a href="#0" data-date={val.id} className={`h--timeline-date timeline-date-${val.id} ${val.id === 1 ? 'h--timeline-date--selected' : ''} `}>Smart System</a></li>
    )
  }

  const FdataContent = (val) => {
    return (
      <li className={`h--timeline-event ${val.id === 1 ? "h--timeline-event--selected" :"" } text-component`}>
        <Row>
          <Col sm={24} md={24} lg={12}>
            <div className="slider-content">
              <div className="number">
                <h4 className="slider-no mb-5">{val.id}</h4>
              </div>
              <div className="slider-text">
                <h2 className="slider-heading text-white mb-5">{val.title}</h2>
                <p className="slider-para text-white">{val.content}</p>
              </div>
            </div>
          </Col>
          <Col sm={24} md={24} lg={12}>
            <div className="slider-img">
              <img src="../../images/feature-img.png" className="img-fluid" alt="" />
            </div>
          </Col>
        </Row>
      </li>
    )
  }
  return (
    <div className="features">
      <div className="container">
        <Row>
          <Col sm={24} md={24} lg={24}>
            <h2 className="sub-heading" align="center">Features</h2>
            <p className="form-para" align="center">This is why you should chose us</p>
            <div className="features-slider">
              <div className="h--timeline js-h--timeline">
                <div className="h--timeline-container">
                  <div className="h--timeline-dates">
                    <div className="h--timeline-line">
                      <ol>
                        {
                          FeatureData.map(Fdata)
                        }
                      </ol>
                      <span className="h--timeline-filling-line" aria-hidden="true"></span>
                    </div>
                  </div>

                  <nav className="h--timeline-navigation-container">
                    <ul>
                      <li><a href="#0" className="text-replace h--timeline-navigation h--timeline-navigation--prev h--timeline-navigation--inactive">Prev</a></li>
                      <li><a href="#0" className="text-replace h--timeline-navigation h--timeline-navigation--next">Next</a></li>
                    </ul>
                  </nav>
                </div>
                <div className="h--timeline-events">
                  <ol>

                    {
                      FeatureData.map(FdataContent)
                    }
                  </ol>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>

  )
}
export default Features;